interface EnvConfig {
  apiUrl: string;
  env: string;
}

const getApiUrl = () => {
  const env = process.env.REACT_APP_ENV || 'development';
  if (env === 'development') {
    return ''; // 开发环境直接使用相对路径
  }
  return process.env.REACT_APP_API_URL || 'https://wincloudaitech.com';
};

const env: EnvConfig = {
  apiUrl: getApiUrl(),
  env: process.env.REACT_APP_ENV || 'development',
};

export const isDevelopment = env.env === 'development';
export const isTest = env.env === 'test';
export const isProduction = env.env === 'production';

export default env; 